export const PLATFORM_BID_OPTION = {
    NONE: 'NONE',
    CUSTOM: 'CUSTOM',
};
